export {InfoCard} from './info-card';
